document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(
    ".uslugi-template-default .page__content",
  );
  if (!container) return;
  const nodes = Array.from(container.childNodes);
  let currentSection = null;
  let newSections = [];

  nodes.forEach((node) => {
    if (node.nodeType === 1 && node.tagName === "H2") {
      currentSection = { heading: node, content: [], preamble: false };
      newSections.push(currentSection);
    } else if (currentSection) {
      currentSection.content.push(node);
    } else {
      if (!newSections.length || !newSections[0].preamble) {
        currentSection = { heading: null, content: [], preamble: true };
        newSections.unshift(currentSection);
      }
      currentSection.content.push(node);
    }
  });

  container.innerHTML = "";
  newSections.forEach((section) => {
    if (
      section.preamble &&
      !section.content.some(
        (n) =>
          n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim() !== ""),
      )
    )
      return;

    const row = document.createElement("div");
    row.className = section.preamble
      ? "page__content-row page__content-row--preamble"
      : "page__content-row";

    const left = document.createElement("div");
    left.className = "page__content-column-left";
    if (section.heading) left.appendChild(section.heading);

    const right = document.createElement("div");
    right.className = "page__content-column-right";
    section.content.forEach((n) => {
      if (n) right.appendChild(n);
    });

    row.appendChild(left);
    row.appendChild(right);
    container.appendChild(row);
  });
});
